import { render, staticRenderFns } from "./ExperimentalItem1.vue?vue&type=template&id=3ab5322a"
import script from "./ExperimentalItem1.vue?vue&type=script&lang=js"
export * from "./ExperimentalItem1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports